import React, { Component } from "react";

export default class Preview extends Component {
  render() {
    return (
      <div>
        <div className=".container">
          <div className="row clientSquares ">
            <div className="span4 clientBox">
              <div className="clientLogoWrapper">
                <img
                  className="clientLogo"
                  src={require("../../assets/img/logo__0004_MGMResorts.png")}
                  alt="client logo"
                />
              </div>
            </div>
            <div className="span4 clientBox">
              <div className="clientLogoWrapper">
                <img
                  className="clientLogo"
                  src={require("../../assets/img/logo__0010_Hart&Beauty.png")}
                  alt="client logo"
                />
              </div>
            </div>
            <div className="span4 clientBox">
              <div className="clientLogoWrapper">
                <img
                  className="clientLogo"
                  src={require("../../assets/img/logo__0007_Microsoft.png")}
                  alt="client logo"
                />
              </div>
            </div>
            <div className="span4 clientBox">
              <div className="clientLogoWrapper">
                <img
                  className="clientLogo"
                  src={require("../../assets/img/logo__0006_TutorGroup.png")}
                  alt="client logo"
                />
              </div>
            </div>
            <div className="span4 clientBox">
              <div className="clientLogoWrapper">
                <img
                  className="clientLogo"
                  src={require("../../assets/img/logo__0005_MonteCarlo.png")}
                  alt="client logo"
                />
              </div>
            </div>
            <div className="span4 clientBox">
              <div className="clientLogoWrapper">
                <img
                  className="clientLogo"
                  src={require("../../assets/img/logo__0008_Siemens.png")}
                  alt="client logo"
                />
              </div>
            </div>
            <div className="span4 clientBox">
              <div className="clientLogoWrapper">
                <img
                  className="clientLogo"
                  src={require("../../assets/img/logo__0003_IHHS.png")}
                  alt="client logo"
                />
              </div>
            </div>
            <div className="span4 clientBox">
              <div className="clientLogoWrapper">
                <img
                  className="clientLogo"
                  src={require("../../assets/img/logo__0001_PlainJoe.png")}
                  alt="client logo"
                />
              </div>
            </div>
            <div className="span4 clientBox">
              <div className="clientLogoWrapper">
                <img
                  className="clientLogo"
                  src={require("../../assets/img/logo__0015_Beacon.png")}
                  alt="client logo"
                />
              </div>
            </div>
            <div className="span4 clientBox">
              <div className="clientLogoWrapper">
                <img
                  className="clientLogo"
                  src={require("../../assets/img/logo__0014_Brandify.png")}
                  alt="client logo"
                />
              </div>
            </div>
            <div className="span4 clientBox">
              <div className="clientLogoWrapper">
                <img
                  className="clientLogo"
                  src={require("../../assets/img/logo__0000_Alibaba.png")}
                  alt="client logo"
                />
              </div>
            </div>
            <div className="span4 clientBox">
              <div className="clientLogoWrapper">
                <img
                  className="clientLogo"
                  src={require("../../assets/img/logo__0013_David&Goliath.png")}
                  alt="client logo"
                />
              </div>
            </div>
          </div>
        </div>
        <div className="row clientSquares ">
          <div className="span4 clientBoxBigLogo">
            <div className="clientBigLogoWrapper">
              <img
                className="clientLogo"
                src={require("../../assets/img/logo__0009_Intel.png")}
                alt="client logo"
              />
            </div>
          </div>
          <div className="span4 clientBoxBigLogo">
            <div className="clientBigLogoWrapper">
              <img
                className="clientLogo"
                src={require("../../assets/img/logo__0011_BMW.png")}
                alt="client logo"
              />
            </div>
          </div>
          <div className="span4 clientBoxBigLogo">
            <div className="clientBigLogoWrapper">
              <img
                className="clientLogo"
                src={require("../../assets/img/logo__0012_Homeland.png")}
                alt="client logo"
              />
            </div>
          </div>
          <div className="span4 clientBoxBigLogo">
            <div className="clientBigLogoWrapper">
              <img
                className="clientLogo"
                src={require("../../assets/img/logo__0002_VistaMetals.png")}
                alt="client logo"
              />
            </div>
          </div>
        </div>
      </div>
    );
  }
}
